import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_6 from '../../assets/press/Press-7-1.webp';

export default function PressPage6() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_1,
      title:
        'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
      link: ROUTE_NAMES.PRESS1,
    },
    {
      image: P_2,
      title:
        '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
      link: ROUTE_NAMES.PRESS2,
    },
    {
      image: P_3,
      title:
        'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
      link: ROUTE_NAMES.PRESS3,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: Bardi VP & Starlife Receive Green Light for 200-unit
          Apartment Project in Hollywood, FL
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_6} alt='press-image' />
        <h2 className='press-page-title'>
          Bardi VP & Starlife Receive Green Light for 200-unit Apartment Project
          in Hollywood, FL
        </h2>
        <span className='author-name'>By Traded Media</span>
        <span className='author-name'>Dec 13, 2023</span>
        <Link
          to={
            'https://traded.co/blog/bardi-vp-starlife-greenlit-for-200-unit-apartment-project-in-florida/'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p style={{ fontWeight: '600' }}>
            A New Chapter in Hollywood, Florida's Real Estate Scene
          </p>
          <p>
            There's a new buzz in Hollywood, Florida's real estate market. A
            joint venture between local developers Bardi VP and Starlife Group
            has recently received the green light to construct a 200-unit
            apartment property. This exciting development, aptly named '21
            Hollywood', is set to rise on a 1.48-acre plot along the bustling
            North Federal Highway.
          </p>
          <p style={{ fontWeight: '600' }}>Unveiling '21 Hollywood': A Peek into the Future</p>
          <p>
            The 13-story '21 Hollywood' is not just another apartment building.
            It's a testament to the evolving landscape of Hollywood, Florida's
            real estate scene. The property will not only house 200 residential
            units but will also feature 10,000 square feet of retail space,
            creating a vibrant blend of residential and commercial spaces.
          </p>
          <p style={{ fontWeight: '600' }}>Location: The Heart of Hollywood</p>
          <p>
            The location of '21 Hollywood' is nothing short of strategic.
            Nestled at 2100 North Federal Highway, the property is set to
            benefit from the area's thriving community and robust
            infrastructure. This prime location is expected to attract a diverse
            range of residents and businesses alike, contributing to the
            property's potential success.
          </p>
          <p style={{ fontWeight: '600' }}>Implications for Real Estate Investors</p>
          <p>
            The approval of '21 Hollywood' is a positive signal for real estate
            investors. It highlights the continuous growth and dynamism of
            Hollywood, Florida's real estate market. For those considering an
            investment in the area, this development serves as an indicator of
            the potential opportunities that lie ahead.
          </p>
          <p style={{ fontWeight: '600' }}>Conclusion: A Promising Addition to Hollywood's Skyline</p>
          <p>
            In conclusion, the approval of the '21 Hollywood' project marks an
            exciting new chapter in Hollywood, Florida's real estate narrative.
            As the property takes shape, it will undoubtedly add a fresh
            dimension to the city's skyline and offer new opportunities for
            residents, businesses, and investors alike.
          </p>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
